export const TOOLTIP_TIMEOUT = 5 * 1000; // 5 seconds
